"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const react_1 = __importStar(require("react"));
const RadixPopover = __importStar(require("@radix-ui/react-popover"));
const hooks_1 = require("../../../hooks");
const Button_1 = require("../Button");
const Popover_styles_1 = require("./Popover.styles");
const useIsMobile = () => {
    const viewport = (0, hooks_1.useViewportSize)();
    return viewport.size === "xs" || viewport.size === "sm";
};
const Root = (_a) => {
    var { modal, children } = _a, props = __rest(_a, ["modal", "children"]);
    const isMobile = useIsMobile();
    return (react_1.default.createElement(RadixPopover.Root, Object.assign({ modal: isMobile || modal }, props), children));
};
const Trigger = RadixPopover.Trigger;
Trigger.defaultProps = {
    onFocusCapture: (event) => {
        event.stopPropagation();
    },
};
const Close = (props) => {
    return (react_1.default.createElement(Popover_styles_1.StyledCloseButton, { asChild: true },
        react_1.default.createElement(Button_1.Button, { appearance: "tertiary", size: "small", "data-closebtn": props["data-closebtn"] },
            react_1.default.createElement(Button_1.Button.Icon, { name: "Cross", "aria-label": "Close" }))));
};
const Content = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children, size = "medium" } = _a, props = __rest(_a, ["children", "size"]);
    return (react_1.default.createElement(RadixPopover.Portal, null,
        react_1.default.createElement(Popover_styles_1.StyledPortal, null,
            react_1.default.createElement(Popover_styles_1.StyledContent, Object.assign({ "$size": size, ref: forwardedRef, sideOffset: 4, collisionPadding: 4 }, props),
                react_1.default.createElement(Popover_styles_1.StyledFallbackCloseButtonContainer, { py: "1.5", px: "2" },
                    react_1.default.createElement(Close, { "data-closebtn": "fallback-close-button" })),
                children))));
});
const Header = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Popover_styles_1.StyledPopoverHeader, Object.assign({ alignItems: "center", gap: "1", p: "1.5 2", ref: forwardedRef }, props),
        react_1.default.createElement(Close, { "data-closebtn": "header-close-button" }),
        children));
});
const Body = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Popover_styles_1.StyledPopoverBody, Object.assign({ p: "2", ref: forwardedRef }, props), children));
});
const Footer = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Popover_styles_1.StyledPopoverFooter, Object.assign({ ref: forwardedRef, justifyContent: "flex-end", alignItems: "center", gap: "1.5", p: "0 2 2 2" }, props), children));
});
Root.displayName = "Popover";
Trigger.displayName = "Popover.Trigger";
Content.displayName = "Popover.Content";
Header.displayName = "Popover.Header";
Body.displayName = "Popover.Body";
Footer.displayName = "Popover.Footer";
exports.Popover = Object.assign(Root, {
    Trigger,
    Content,
    Header,
    Body,
    Footer,
});
//# sourceMappingURL=Popover.js.map